export enum PeriodEnum {
  TODAY = "Today",
  WEEK = "Week",
  MONTH = "Month",
}
